import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModeratorRequestDailogComponent } from '../moderator-request-dailog/moderator-request-dailog.component';
import { UsersListDailogComponent } from '../users-list-dailog/users-list-dailog.component';
@Component({
  selector: 'app-alerts-dailog',
  templateUrl: './alerts-dailog.component.html',
  styleUrls: ['./alerts-dailog.component.scss']
})
export class AlertsDailogComponent implements OnInit {

  constructor(public dialog: MatDialog,
    public matDialogRef: MatDialogRef<AlertsDailogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
    ) { 
      console.log("dialog data =>",data.element);
      
    }

  ngOnInit() {
  }
  closeDialog(){
    this.matDialogRef.close()
  }
  close(){
    this.matDialogRef.close({delete:true})
  }
}
